import { RecordFolderArea } from 'src/graphql';
import { useRecordFolderAssignments } from 'src/graphql/entities/record-folder-assignment';
import { useRecordFolders } from './use-record-folders';

export const VIEW_ASSIGNMENT_ENTITIES = ['Conversation', 'CustomView'];

export const useViewRecordFolders = () => {
  const {
    recordFolderAssignments,
    reorderAssignments,
    isLoading: assignmentsLoading,
  } = useRecordFolderAssignments({
    entityFilter: VIEW_ASSIGNMENT_ENTITIES,
  });

  const {
    recordFolders,
    manageableRecordFolders,
    isEnabled,
    isLoading: foldersLoading,
  } = useRecordFolders({
    area: RecordFolderArea.View,
    assignmentEntityFilter: VIEW_ASSIGNMENT_ENTITIES,
    recordFolderAssignments,
  });

  return {
    recordFolders,
    manageableRecordFolders,
    recordFolderAssignments,
    reorderAssignments,
    isEnabled,
    isLoading: assignmentsLoading || foldersLoading,
  };
};
